export const CLEAR_ALERT = 'CLEAR_ALERT';
export const CLEAR_SONG_TIMELINE = 'CLEAR_SONG_TIMELINE';
export const FETCH_ARTIST_HISTORY = 'FETCH_ARTIST_HISTORY';
export const FETCH_CONCERT_VIEW = 'FETCH_CONCERT_VIEW';
export const LOAD_ACTIVATE_ANNOUNCEMENTS = 'LOAD_ACTIVATE_ANNOUNCEMENTS';
export const LOAD_ANNOUNCEMENTS = 'LOAD_ANNOUNCEMENTS';
export const LOAD_AUDIENCE_ANNOTATIONS = 'LOAD_AUDIENCE_ANNOTATIONS';
export const LOAD_AUDIENCE_AGGREGATE = 'LOAD_AUDIENCE_AGGREGATE';
export const LOAD_AUDIENCE_TIMELINE = 'LOAD_AUDIENCE_TIMELINE';
export const LOAD_SONG_AGGREGATE = 'LOAD_SONG_AGGREGATE';
export const LOAD_SONG_ANNOTATIONS = 'LOAD_SONG_ANNOTATIONS';
export const LOAD_SONG_DISCOVERY = 'LOAD_SONG_DISCOVERY';
export const LOAD_SONG_LOCATIONS = 'LOAD_SONG_LOCATIONS';
export const LOAD_SONG_PLAYLISTS = 'LOAD_SONG_PLAYLISTS';
export const LOAD_SONG_SOURCES = 'LOAD_SONG_SOURCES';
export const LOAD_SONG_TIMELINE = 'LOAD_SONG_TIMELINE';
export const LOAD_SONG_TOP_CITIES = 'LOAD_SONG_TOP_CITIES';
export const LOAD_TOP_TRACKS = 'LOAD_TOP_TRACKS';
export const MORE_ARTIST_HISTORY = 'MORE_ARTIST_HISTORY';
export const SET_ALERT = 'SET_ALERT';
export const SET_PLATFORM = 'SET_PLATFORM';
export const UNLOAD_CURRENT_ARTIST = 'UNLOAD_CURRENT_ARTIST';
export const UPDATE_ANNOUNCEMENTS = 'UPDATE_ANNOUNCEMENTS';
